module.exports = __webpack_public_path__ + "static/img/3.5e9a8324.png";